<template>
    <div class="year-weight-add">
      <el-form
        ref="editForm"
        label-width="130px"
        :model="editJson"
        :rules="rules"
        >
        <el-form-item label="姓名" prop="wkNo">
          <selecter ref="empSelect" v-model="editJson.wkNo" :jobNo="editJson.wkNo" :name="editJson.wkName" :disabled="editData.id"></selecter>
        </el-form-item>
        <el-form-item label="年份" prop="year">
          <el-date-picker
            v-model="editJson.year"
            type="year"
            format="yyyy 年"
            value-format="yyyy"
            placeholder="选择年份"
            style="width: 100%;"
            :disabled="editData.id"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="期次" prop="period">
          <common-select ref="period" v-model="editJson.period" :list="periodList" optLabel="label" optValue="value" placeholder="期次" :disabled="editData.id" clearable></common-select>
        </el-form-item>
        <el-form-item label="排序人" prop="configWkNo">
          <selecter ref="sortPerson" v-model="editJson.configWkNo" :jobNo="editJson.configWkNo" :name="editJson.configWkName"></selecter>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" placeholder="请输入备注" maxlength="512" :autosize="{ minRows: 3, maxRows: 5 }" resize="none" v-model="editJson.remarks"></el-input>
        </el-form-item>
        <el-form-item label-width="0" class="atb-no-margin">
          <div class="atb-text-right">
            <!-- 保存 -->
            <el-button class="atb-dialog-confirm" type="primary" @click="submit">保存</el-button>
            <!-- 取消 -->
            <el-button
              class="atb-dialog-cancel"
              type="cancel"
              @click="$parent.$parent.hide()"
            >取消</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </template>
  <script>
  import editMixin from "@/mixins/edit.mixin";
  import _ from "lodash";
  import { PERIOD_LIST } from '@/utils/period-enum.js';
  
  export default {
    name: 'YearWeightUpdate',
    components: {
      selecter: () => import('@/component/global/customerSelect'),
    },
    mixins: [editMixin],
    props: {
      // 编辑信息
      editData: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        id: "id",
        rules: {
          wkNo: [{ required: true, message: '"姓名"为必填项', trigger: "change" }],
          year: [{ required: true, message: '"年份"为必填项', trigger: 'change' }],
          period: [{ required: true, message: '"期次"为必填项', trigger: 'change' }],
          configWkNo: [{ required: true, message: '"姓名"为必填项', trigger: "change" }]
        },
        addApi: this.$api.period.ImportantSortConfig.AddImportantSortConfig,
        editApi: this.$api.period.ImportantSortConfig.UpdateImportantSortConfig,
        editMethod: "post",
        periodList:  _.cloneDeep(PERIOD_LIST),
      };
    },
    methods: {
      resetSubmitParams(params) {
        const self = this;
        const resetParam = {
          year: params.year ? parseInt(params.year) : undefined,
          period: params.period,
          wkNo: params.wkNo,
          wkName: self.$refs.empSelect.currentOption.name,
          configWkNo: params.configWkNo,
          configWkName: self.$refs.sortPerson.currentOption.name,
          isEnable: 1,
          remarks: params.remarks
        };
        return resetParam;
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  ::v-deep {
    .el-select, .el-autocomplete {
      width: 100%;
    }
    .algin-left .el-form-item__content {
      text-align: left;
    } 
  }
  </style>
  